import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon, BellRingIcon, CircleIcon, MailIcon, ReplyIcon, ForwardIcon, MoreHorizontalIcon } from 'lucide-react';
export const BrandedEmailInterface = () => {
  return <div className="w-full h-full flex flex-col relative bg-gray-100 rounded-[24px] shadow-lg overflow-hidden" data-id="element-179">
      {/* Outlook desktop header */}
      <div className="w-full bg-[#0078D4] text-white flex items-center px-3 py-1 flex-shrink-0" data-id="element-180">
        {/* Outlook logo and title */}
        <div className="flex items-center" data-id="element-181">
          <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24" fill="currentColor" data-id="element-182"></svg>
        </div>
        {/* Window controls - minimized for Outlook */}
        <div className="ml-auto flex space-x-4" data-id="element-183"></div>
      </div>
      {/* Email client interface */}
      <div className="flex-grow p-1 sm:p-2 bg-gray-100 overflow-hidden" data-id="element-184">
        <div className="bg-white border border-gray-200 rounded-md shadow-sm h-full flex flex-col overflow-hidden" data-id="element-185">
          {/* Compact email header with sender info and action buttons */}
          <div className="flex justify-between items-center px-2 sm:px-4 py-1.5 border-b border-gray-200 flex-shrink-0" data-id="element-186">
            <div className="flex-1 min-w-0" data-id="element-187">
              <h1 className="text-xs sm:text-sm font-semibold text-gray-900 truncate pr-2" data-id="element-188">
                <span className="block sm:hidden" data-id="element-189">
                  Reminder: Submit Documents
                </span>
                <span className="hidden sm:block" data-id="element-190">
                  Reminder: Binding Documents for ACME
                </span>
              </h1>
              <div className="flex items-center flex-wrap" data-id="element-191">
                <div className="w-4 h-4 rounded-full bg-blue-100 flex items-center justify-center mr-1.5 flex-shrink-0" data-id="element-192">
                  <span className="text-[8px] font-bold text-blue-600" data-id="element-193">A</span>
                </div>
                <span className="text-[10px] text-gray-600 truncate" data-id="element-194">
                  ACME Corp. &lt;jsmith@acme.com&gt;
                </span>
                <span className="text-[10px] text-gray-400 ml-1 sm:ml-2 flex-shrink-0" data-id="element-195">
                  to me
                </span>
              </div>
            </div>
            <div className="flex space-x-1 ml-2 flex-shrink-0" data-id="element-196">
              <button className="p-1 text-gray-500 hover:bg-gray-100 rounded-full" data-id="element-197">
                <ReplyIcon className="h-3.5 w-3.5" data-id="element-198" />
              </button>
              <button className="hidden sm:flex p-1 text-gray-500 hover:bg-gray-100 rounded-full" data-id="element-199">
                <ForwardIcon className="h-3.5 w-3.5" data-id="element-200" />
              </button>
              <button className="p-1 text-gray-500 hover:bg-gray-100 rounded-full" data-id="element-201">
                <MoreHorizontalIcon className="h-3.5 w-3.5" data-id="element-202" />
              </button>
            </div>
          </div>
          {/* Email body - centered content with proper spacing */}
          <div className="p-2 flex-grow overflow-auto" data-id="element-203">
            <div className="flex flex-col items-center w-full max-w-[95%] xs:max-w-[90%] sm:max-w-[80%] mx-auto" data-id="element-204">
              {/* Top section with logo on left and progress pill on right */}
              <div className="flex justify-between items-start mb-2 w-full" data-id="element-205">
                {/* Company logo - left aligned */}
                <div data-id="element-206">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ebckT2iyvbVwKRT7DWhE49/Highpoint_Logo_1920x1080_%281%29.png" alt="Highpoint Logo" className="h-4 sm:h-5 w-auto" data-id="element-207" />
                </div>
                {/* Progress pill on the right */}
                <div className="flex flex-col items-center" data-id="element-208">
                  <div className="w-12 sm:w-16 h-2 sm:h-3 bg-gray-200 rounded-full overflow-hidden" data-id="element-209">
                    <div className="h-full bg-green-500 rounded-full flex items-center justify-center text-[7px] sm:text-[8px] font-medium text-white" style={{
                    width: '75%'
                  }} data-id="element-210">
                      75%
                    </div>
                  </div>
                  <p className="text-[6px] sm:text-[7px] text-gray-500 mt-0.5" data-id="element-211">
                    3/4 completed
                  </p>
                </div>
              </div>
              {/* Blue notification box with bell icon */}
              <div className="bg-[#2E6BFF] p-1.5 sm:p-2 rounded-md text-white mb-2 w-full flex flex-col items-center" data-id="element-212">
                <BellRingIcon className="h-4 w-4 sm:h-5 sm:w-5 mb-0.5" data-id="element-213" />
                <div className="text-center" data-id="element-214">
                  <p className="font-medium text-xs sm:text-sm" data-id="element-215">
                    Reminder to submit binding documents to ACME
                  </p>
                  <p className="text-[10px] sm:text-xs mt-0.5 opacity-90" data-id="element-216">
                    POL112312333
                  </p>
                </div>
              </div>
              {/* Centered intro */}
              <div className="mb-2 text-center w-full" data-id="element-217">
                <p className="text-[10px] sm:text-xs text-gray-700" data-id="element-218">
                  Hi John, you have one outstanding checklist item to complete:
                </p>
              </div>
              {/* Checklist with dividers - widened and centered */}
              <div className="mb-3 w-full" data-id="element-219">
                <div className="w-full border border-gray-200 rounded-md" data-id="element-220">
                  {/* Item 1 - Completed */}
                  <div className="py-1 px-2 flex items-center border-b border-gray-200" data-id="element-221">
                    <div className="flex-shrink-0 mr-2 w-3.5 sm:w-4 h-3.5 sm:h-4 rounded-full bg-green-100 flex items-center justify-center text-xs font-medium text-green-600" data-id="element-222">
                      <CheckIcon className="h-2.5 sm:h-3 w-2.5 sm:w-3" data-id="element-223" />
                    </div>
                    <div data-id="element-224">
                      <h5 className="font-medium text-[10px] sm:text-xs text-gray-900" data-id="element-225">
                        ACORD Applications
                      </h5>
                    </div>
                  </div>
                  {/* Item 2 - Completed */}
                  <div className="py-1 px-2 flex items-center border-b border-gray-200" data-id="element-226">
                    <div className="flex-shrink-0 mr-2 w-3.5 sm:w-4 h-3.5 sm:h-4 rounded-full bg-green-100 flex items-center justify-center text-xs font-medium text-green-600" data-id="element-227">
                      <CheckIcon className="h-2.5 sm:h-3 w-2.5 sm:w-3" data-id="element-228" />
                    </div>
                    <div data-id="element-229">
                      <h5 className="font-medium text-[10px] sm:text-xs text-gray-900" data-id="element-230">
                        TRIA Form
                      </h5>
                    </div>
                  </div>
                  {/* Item 3 - Pending (highlighted in yellow) */}
                  <div className="py-1 px-2 flex items-center border-b border-gray-200 bg-yellow-100" data-id="element-231">
                    <div className="flex-shrink-0 mr-2 w-3.5 sm:w-4 h-3.5 sm:h-4 flex items-center justify-center" data-id="element-232">
                      <CircleIcon className="h-2.5 sm:h-3 w-2.5 sm:w-3 text-black" data-id="element-233" />
                    </div>
                    <div data-id="element-234">
                      <h5 className="font-medium text-[10px] sm:text-xs text-gray-900" data-id="element-235">
                        Underlying GL Policy
                      </h5>
                    </div>
                  </div>
                  {/* Item 4 - Completed */}
                  <div className="py-1 px-2 flex items-center" data-id="element-236">
                    <div className="flex-shrink-0 mr-2 w-3.5 sm:w-4 h-3.5 sm:h-4 rounded-full bg-green-100 flex items-center justify-center text-xs font-medium text-green-600" data-id="element-237">
                      <CheckIcon className="h-2.5 sm:h-3 w-2.5 sm:w-3" data-id="element-238" />
                    </div>
                    <div data-id="element-239">
                      <h5 className="font-medium text-[10px] sm:text-xs text-gray-900" data-id="element-240">
                        Supplemental Application(s)
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
              {/* Action button - VIEW REQUEST - at the bottom */}
              <div className="flex justify-center" data-id="element-241">
                <a href="#" className="inline-flex items-center justify-center px-3 py-1.5 border border-transparent text-[10px] sm:text-xs font-medium rounded-md text-white bg-[#2E6BFF] hover:bg-[#1D5AFF] shadow-sm transition-colors duration-200 touch-action-manipulation" data-id="element-242">
                  VIEW REQUEST
                  <ArrowRightIcon className="ml-1 sm:ml-1.5 h-3 sm:h-3.5 w-3 sm:w-3.5" data-id="element-243" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};